export const USER_INFO = 'USER_INFO';


/**
 * Change user information including token
 * payload.data: field data in response api login
 */
export function updateUserInfo(data) {
    return { type: USER_INFO, data };
}